import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AppLayout from "../layouts/AppLayout";
import AuthLayout from "../layouts/AuthLayout";

// Auth Pages
import Login from "../Pages/auth/LogIn";
import Contact from "../Pages/auth/Contact";
import OTP from "../Pages/auth/Otp";

// Dashboard Pages
import Dashboard from "../Pages/Dashboard";
import Streams from "../Pages/Stream/Streams";
import AddStream from "../Pages/Stream/AddStream";
import ShowStreams from "../Pages/Stream/ShowStreams";
import UpdateStreams from "../Pages/Stream/UpdateStreams";
import Search from "../Pages/Search";
import Logs from "../Pages/Logs";
import Predictions from "../Pages/Predictions";
import { useRecoilState } from "recoil";
import { authState } from "../Recoil/RecoilState";
import { useEffect } from "react";
import Settings from "../Pages/Settings/Settings";
import Charts from "../Pages/Charts";
import ShopliftingMain from "../Pages/Shoplifting/ShopliftingMain";
import NoEntryMain from "../Pages/NoEntry/NoEntryMain";
import ExitBlockingMain from "../Pages/ExitBlocking/ExitBlockingMain";
import LostFoundMain from "../Pages/LostFound/LostFoundMain";
import RequireSuperadmin from "../Components/Auth/RequireSuperadmin";
import RequireFeature from "../Components/Auth/RequireFeature";
import WorkspaceMembers from "../Pages/Workspace/WorkspaceMembers";
import WorkspaceSettings from "../Pages/Workspace/WorkspaceSettings";
import WorkspaceCameras from "../Pages/Workspace/WorkspaceCameras";

const AppRouter = () => {
  const [authRecoil, setAuthRecoil] = useRecoilState(authState);

  useEffect(() => {
    if (localStorage?.token && !authRecoil?.token) {
      setAuthRecoil({
        isAuthenticated: true,
        expire: localStorage.expire,
        token: localStorage.token,
        role: localStorage.role,
      });
    }
  }, [authRecoil?.token, setAuthRecoil]);

  return (
    <Router>
      <Routes>
        {!authRecoil?.token ? (
          // Unauthenticated Routes
          <>
            <Route element={<AuthLayout />}>
              <Route path="/login" element={<Login />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/otp" element={<OTP />} />
              <Route path="/" element={<Navigate to="/login" />} />
            </Route>
          </>
        ) : (
          // Authenticated Routes
          <>
            <Route element={<AppLayout />}>
              <Route path="/" element={<Dashboard />} />
              <Route path="/streams" element={<Streams />} />
              <Route path="/streams/add-stream" element={<AddStream />} />
              <Route path="/streams/show-streams" element={<ShowStreams />} />
              <Route
                path="/streams/update-streams"
                element={<UpdateStreams />}
              />
              <Route path="/frames-search" element={<Search />} />
              <Route path="/predictions" element={<Predictions />} />
              <Route path="/setting" element={<Settings />} />
              <Route path="/Setting" element={<Settings />} />
              <Route path="/charts" element={<Charts/>} />
              <Route path="/shoplifting/*" element={<ShopliftingMain />} />
              <Route path="/no-entry/*" element={<NoEntryMain />} />
              <Route path="/exit-blocking/*" element={<ExitBlockingMain />} />
              <Route element={<RequireFeature feature="lost_found" />}>
                <Route path="/lost-found/*" element={<LostFoundMain />} />
              </Route>
              <Route path="/loss-found/*" element={<Navigate to="/lost-found" replace />} />
              <Route path="/logs" element={<Logs />} />

              {/* Workspace management: superadmin only */}
              <Route element={<RequireSuperadmin />}>
                <Route path="/workspace/members" element={<WorkspaceMembers />} />
                <Route path="/workspace/settings" element={<WorkspaceSettings />} />
                <Route path="/workspace/cameras" element={<WorkspaceCameras />} />
                <Route path="/workspace" element={<Navigate to="/workspace/members" />} />
              </Route>
            </Route>
          </>
        )}


        {/* Catch All */}
        <Route path="*" element={<Navigate to="/" />} />
      </Routes>
    </Router>
  );
};

export default AppRouter;
